import * as React from 'react';

import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';

import { blackText, blue, blueGrayText } from '../../constants/Colors';

interface Props {
  steps: string[];
  activeStep: number;
}

export default function CustomStepper(props: Props): React.ReactElement {
  const { steps, activeStep } = props;

  const styles = {
    label: {
      '.MuiStepLabel-iconContainer.Mui-active svg': {
        color: blue
      },
      '.MuiStepLabel-iconContainer.Mui-completed svg': {
        color: blue
      },
      '.MuiStepLabel-iconContainer.Mui-disabled svg': {
        color: blueGrayText
      },
      '.MuiStepLabel-labelContainer span': {
        fontSize: '11px',
        marginTop: '8px',
        whiteSpace: 'pre-wrap'
      },
      '.MuiStepLabel-labelContainer span.Mui-active': {
        color: blackText
      },
      '.MuiStepLabel-labelContainer span.Mui-completed': {
        color: blackText
      },
      '.MuiStepLabel-labelContainer span.Mui-disabled': {
        color: blueGrayText
      }
    }
  };

  return (
    <Box sx={{ marginBottom: '32px', width: '100%' }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel sx={styles.label}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
